module.exports = __webpack_public_path__ + "img/navbarLogo.7c6a0969.svg";